/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActionStiDto } from '../../models/action-sti-dto';

export interface ChangementStatutSti$Params {
  /**
   * Id sti
   */
  idSti: string;
  body: ActionStiDto;
}

export function changementStatutSti(
  http: HttpClient,
  rootUrl: string,
  params: ChangementStatutSti$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<{}>> {
  const rb = new RequestBuilder(rootUrl, changementStatutSti.PATH, 'put');
  if (params) {
    rb.path('idSti', params.idSti, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'blob', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{}>;
    })
  );
}

changementStatutSti.PATH = '/v2/stis/{idSti}/action';
